import { render, staticRenderFns } from "./BillingOrderPage.vue?vue&type=template&id=2b3381e4&scoped=true"
import script from "./BillingOrderPage.vue?vue&type=script&lang=js"
export * from "./BillingOrderPage.vue?vue&type=script&lang=js"
import style0 from "./BillingOrderPage.vue?vue&type=style&index=0&id=2b3381e4&prod&lang=stylus&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2b3381e4",
  null
  
)

export default component.exports